<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="People and Orgs UI Library"
    seFeDataSubtitle="A set of apps and libs to be used within the People and Organizations domain"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Overview"></se-fe-card-header>
      <se-fe-card-content>
        <p>This is a collection of ui components / angular elements that can be consumed by other standalone applications.</p>

        <p>This project uses a <a href="https://nx.dev/" target="_blank">nx monorepo build system</a></p>

        <p>
           A monorepo is a single repo that holds the code for multiple apps and libraries.
           Given that we work with a lot of the same components and logic across our work,
           using a monorepo allows us to have a base of shared code with easy visibility and access to use in our apps and elements,
           keeping our code DRY. It also means we only have to manage a single set of dependencies for all the frontend work we've consolidated in this repo.
        </p>

        <p>Some nice things about Nx that we try to use:</p>
        <ul>
          <li>
            <a href="https://nx.dev/concepts/affected" target="_blank">Affected</a> - Can use to only run commands on targets affected by changes.
            Our build pipeline should only build and unit test affected targets.
          </li>
          <li>
            <a href="https://nx.dev/core-features/enforce-module-boundaries" target="_blank">Tags</a> - Can tag libraries to set module boundaries.
            By default our component generator adds a tag based on the containing library.
          </li>
          <li>
            <a href="https://nx.dev/concepts/more-concepts/applications-and-libraries" target="_blank">Apps as containers</a> - 80% of code in libraries, 20% in the app.
            Think about our elements or apps as shells, with the majority of the work in shared or feature libraries.
          </li>
        </ul>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Development"></se-fe-card-header>
      <se-fe-card-content>
        <p>To start a single project</p>
        <se-fe-docs-code [code]="code.start"></se-fe-docs-code>
        <p>To start a single project against local services</p>
        <se-fe-docs-code [code]="code.startDev"></se-fe-docs-code>
        <p>To see the single running project, navigate to https://people-and-orgs.ui.sportngin.com.dev/[project-name]. The exception to this is se-household-setup; refer to its <a routerLink="/se-household-setup/overview">docs page</a> for more information.</p>
        <p>If you need all projects running simultaneously you can run:</p>
        <se-fe-docs-code [code]="code.startAll"></se-fe-docs-code>
        <p>If you need all projects to automatically rebuild when files change you can run the following in two separate terminal windows:</p>
        <se-fe-docs-code [code]="code.startWatch"></se-fe-docs-code>
        <p>To see the docs when running all projects, navigate to <a href="https://people-and-orgs.ui.sportngin.com.dev/docs/index.html">https://people-and-orgs.ui.sportngin.com.dev/docs/index.html</a></p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Code Generators"></se-fe-card-header>
      <se-fe-card-content>
        <p>New Library</p>
        <se-fe-docs-code [code]="code.glib"></se-fe-docs-code>
        <p>New Component</p>
        <se-fe-docs-code [code]="code.gc"></se-fe-docs-code>
        <p>New Element</p>
        <se-fe-docs-code [code]="code.elem"></se-fe-docs-code>
        <p>* Note: gelem currently creates an unnecessary "app" directory along with an unnecessary "environments" directory inside the new project. These can be deleted.</p>
        <p>New App</p>
        <se-fe-docs-code [code]="code.newApp"></se-fe-docs-code>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Additional Resources"></se-fe-card-header>
      <se-fe-card-content>
        <ul>
          <li>
            <a href="https://medium.com/showpad-engineering/how-to-organize-and-name-applications-and-libraries-in-an-nx-monorepo-for-immediate-team-wide-9876510dbe28" target="_blank">Organizing Apps and Libs in an Nx monorepo</a>
          </li>
          <li>
            <a href="https://github.com/nrwl/nx-examples" target="_blank">NX Examples</a>
          </li>
          <li>
            <a href="https://fyodor.io/nx-based-monorepo-pains-and-gains/" target="_blank">NX Pains and Gains</a>
          </li>
        </ul>
      </se-fe-card-content>
    </se-fe-card>

  </div>
</se-fe-page>
